<template>
	<form id="add-domain-form" novalidate class="needs-validation" :class="{'was-validated':hasError}" v-on:submit.prevent="saveForm">

		<error :error="error"></error>

		<div class="form-row">
			<div class="col-sm-6">
				<div class="m-t form-group required">
						<label class="control-label required" for="email-input">Primary Email</label>
						<input id="email-input" class="form-control" :class="{'is-invalid':emailError.length}" placeholder="" v-model="email"/>
						<div class="invalid-feedback" v-if="emailError">{{EmailError}}</div>
				</div>
			</div>
			<div class="col-sm-6">

			</div>
		</div>
		<div class="form-row">
			<div class="col-sm-12">
				<div class="m-t form-group required">
					<label class="control-label required" for="other-emails-input">Other Emails</label>
					<!--<input id="other-emails-input" class="form-control" :class="{'is-invalid':otherEmailsError.length}" placeholder="" v-model="otherEmails"/>-->
					<input-token :tags.sync="otherEmails" :addTagOnBlur="true" validation="email" ></input-token>
				</div>
			</div>
			<div class="col-sm-6">
			</div>
		</div>

		<div class="form-row" v-if="step===2">
			<div class="col-sm-12">
				<div class="m-t form-group required">
					<label class="control-label required" for="other-emails-input">Matched Emails</label>
					<input-token :tags.sync="matchedEmails" :addTagOnBlur="true" validation="email"></input-token>
				</div>
			</div>
			<div class="col-sm-6">
			</div>
		</div>

		<div class="form-row">
			<div class="col-sm-12">
				<div class="text-right">
					<button v-if="step===1" type="button" class="btn btn-outline-primary px-3" @click="nextStep">Next</button>
					<button v-if="step===2" type="submit" class="btn btn-outline-primary px-3">Add</button>
					<button type="button" class="btn btn-outline-primary px-3" @click="closeForm">Cancel</button>						
				</div>
			</div>
		</div>

	</form>
</template>

<script>
	import InputToken from './InputToken'
	import Error from './Error'

	import api from '../api'
	import store from '../state'
	import router from '../router'

	export default {
		name: 'AddEmailForm',
		components: {InputToken, Error},
		data() {
			return {
				email: '',
				otherEmails: [],
				candidateEmails: [],
				matchedEmails: [],
				step:1,
				error: '',
				emailError:''
			}
		},
		methods: {
			closeForm() {
				this.clear();
				this.$emit('close-add-email');
			},
			clear() {
				this.email = '';
				this.otherEmails = [];
				this.candidateEmails = [];
				this.matchedEmails = [];
				this.step = 1;
				this.error = '';
				this.emailError = '';
			},
			reset() {
				if (this.step == 2) {
					this.step = 1;
					this.matchedEmails = [];
				}
			},
			async nextStep() {
				
				//Perform any actions
				try {
					var response = await api.get(`email/${this.email}/candidates?otherEmails=${this.otherEmails.join(',')}`);	
					this.candidateEmails.push(...response.data);
					this.matchedEmails.push(...response.data);

					this.step++;
				}
				catch(err) {
					this.error = err; //Get the string representation of the error
				}
				
			},
			async saveForm() {
				
				try
				{
					var response = await api.post('email', {value:this.email, otherEmails: this.otherEmails.join(','), matchedEmails: this.matchedEmails.join(','), excludedEmails: this.excludedEmails.join(',')});	
						
					store.dispatch('getEmailsAsync');
					this.closeForm();
				}
				catch(err) {
					this.error = err;
				}
			},
			isNumeric(value) {
				return /^\d+$/.test(value);
			}
		},
		computed: {
			hasError() {
				return (!!this.domainError || !!this.totalError);
			},
			excludedEmails() {
				//Get the different between the candidate emails and the matched emails
				return this.candidateEmails.filter(x => !this.matchedEmails.includes(x));
			}
		},
		watch: {
			otherEmails(values) {
				this.reset();
			},
			email(values) {
				this.reset();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/AddEmailForm.vue